import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"
import _imports_0 from './assets/images/shinam1_logo_new.svg'


const _hoisted_1 = { class: "header-contacts" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item-contact" }
const _hoisted_5 = {
  key: 0,
  class: "item-contact item-support"
}
const _hoisted_6 = {
  key: 0,
  class: "menu-titles-wrapper"
}
const _hoisted_7 = { class: "menu-item-container" }
const _hoisted_8 = { class: "first" }
const _hoisted_9 = { class: "first-container" }
const _hoisted_10 = { class: "second-container" }
const _hoisted_11 = {
  key: 0,
  class: "second"
}
const _hoisted_12 = { class: "personal-container" }
const _hoisted_13 = { class: "bucket text-center" }
const _hoisted_14 = { class: "bucket-label" }
const _hoisted_15 = { class: "personal" }
const _hoisted_16 = { class: "account-label" }
const _hoisted_17 = { class: "main-wrapper" }
const _hoisted_18 = { class: "d-flex w-100 flex-class" }
const _hoisted_19 = { class: "footer-catalog" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "v-title" }, "Каталог", -1)
const _hoisted_21 = { class: "footer-for-buyer" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "v-title" }, "Покупателю", -1)
const _hoisted_23 = { class: "footer-about" }
const _hoisted_24 = {
  key: 1,
  class: "footer-menu-mobile-items"
}
const _hoisted_25 = { class: "menu-items-wrapper" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "v-title" }, "Как с нами связаться", -1)
const _hoisted_27 = { class: "footer-contacts" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "item-contact d-flex align-center" }
const _hoisted_30 = {
  key: 2,
  class: "public-offer-agreement"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Договор публичной оферты и", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, " Политика обработки персональных данных", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_form_modal = _resolveComponent("form-modal")!
  const _component_additional_modal = _resolveComponent("additional-modal")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, { flat: "" }, _createSlots({
        append: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["header-contacts-menu", { 'mobile-header-contacts': _ctx.isMobile }]),
            onMouseover: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showSecondMenu(true))),
            onMouseleave: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showSecondMenu(false)))
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_menu, null, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              icon: "mdi-phone",
                              size: "32",
                              color: "blue"
                            })
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactsPhone, (item, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: index,
                                value: index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    onClick: _withModifiers(($event: any) => (_ctx.handleLink(item)), ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.contact), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contactsPhone, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "contact",
                      onClick: _withModifiers(($event: any) => (_ctx.handleLink(item)), ["prevent"])
                    }, [
                      _createVNode(_component_v_img, {
                        width: "30",
                        src: `${_ctx.environment}${item.link}`
                      }, null, 8, ["src"]),
                      _createElementVNode("span", _hoisted_4, "+375 " + _toDisplayString(item.contact), 1)
                    ], 8, _hoisted_3))
                  }), 128)),
              _createElementVNode("div", {
                class: "support-form-container contact",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleLink(_ctx.support)), ["prevent"]))
              }, [
                _createVNode(_component_v_img, {
                  width: "30",
                  src: `${_ctx.environment}${_ctx.support.link}`
                }, null, 8, ["src"]),
                (!_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.support.contact), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleMenuItem(0)), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Шины легковые")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleMenuItem(9)), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Шины грузовые")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleMenuItem(1)), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Диски")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handleMenuItem(2)), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("АКБ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.handleMenuItem(8)), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Автокейсы")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_v_menu, null, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                              default: _withCtx(() => [
                                _createTextVNode("Покупателю")
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buyerItems, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: index,
                                    value: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, {
                                        onClick: _withModifiers(($event: any) => (_ctx.handleBuyerItem(index)), ["prevent"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.handleMenuItem(6)), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("О нас")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_Transition, null, {
                      default: _withCtx(() => [
                        (_ctx.isHiddenSecondMenuContainer)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_v_btn, {
                                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.handleMenuItem(3)), ["prevent"]))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Автоковрики")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.handleMenuItem(5)), ["prevent"]))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Центровочные кольца")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.handleMenuItem(7)), ["prevent"]))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Болты и гайки")
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_badge, {
                        content: _ctx.countOrders,
                        color: "info"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-cart",
                            size: "40",
                            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.handleClick(true)), ["stop"]))
                          })
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.bucketLabel), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      (!_ctx.isSign)
                        ? (_openBlock(), _createBlock(_component_v_avatar, {
                            key: 0,
                            color: "white",
                            class: "position-relative",
                            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.handleClick(false)), ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: _ctx.signStatusIcon,
                                size: "40"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_menu, {
                            key: 1,
                            modelValue: _ctx.accountMenuModel,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountMenuModel) = $event))
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_avatar, _mergeProps({
                                color: "white",
                                class: "position-relative"
                              }, props), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _ctx.signStatusIcon,
                                    size: "40"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountMenuItems, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: index,
                                      value: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, {
                                          onClick: _withModifiers(($event: any) => (_ctx.handleMenuItem(item.value)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.accountLabel), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 34),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_v_badge, {
                  content: _ctx.countOrders,
                  color: "info",
                  onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.handleClick(true)), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-cart",
                      size: "28",
                      color: "blue"
                    })
                  ]),
                  _: 1
                }, 8, ["content"]),
                (_ctx.isSign)
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 0,
                      modelValue: _ctx.accountMenuModel,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.accountMenuModel) = $event))
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_avatar, _mergeProps({
                          color: "white",
                          class: "position-relative ml-4"
                        }, props), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              icon: _ctx.signStatusIcon,
                              size: "28",
                              color: "blue"
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountMenuItems, (item, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: index,
                                value: index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    onClick: _withModifiers(($event: any) => (_ctx.handleMenuItem(item.value)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_v_avatar, {
                      key: 1,
                      color: "white",
                      class: "position-relative ml-4",
                      onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.handleClick(false)), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: _ctx.signStatusIcon,
                          size: "28",
                          color: "blue"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_img, {
            class: _normalizeClass(["custom-logo-image", { 'mobile-header-logo': _ctx.isMobile }]),
            "aspect-ratio": "4/3",
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toMainPage()), ["prevent"]))
          }, null, 8, ["class"])
        ]),
        _: 2
      }, [
        (_ctx.isMobile)
          ? {
              name: "prepend",
              fn: _withCtx(() => [
                _createVNode(_component_v_app_bar_nav_icon, {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.drawer = !_ctx.drawer), ["prevent"]))
                })
              ]),
              key: "0"
            }
          : undefined
      ]), 1024),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_navigation_drawer, {
              modelValue: _ctx.drawer,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.drawer) = $event)),
              temporary: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider),
                _createVNode(_component_v_list, {
                  density: "compact",
                  nav: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileTabs, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: index,
                        title: item.title,
                        value: item.value,
                        class: _normalizeClass({ 'main-mobile-menu-item': item.isMain }),
                        onClick: _withModifiers(($event: any) => (_ctx.handleMobileMenu(item.value)), ["prevent"])
                      }, null, 8, ["title", "value", "class", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_v_footer, { class: "d-flex" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: index,
                            value: index,
                            active: _ctx.activeTab === item.title,
                            onClick: _withModifiers(($event: any) => (_ctx.setActiveTab(item.title)), ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                onClick: _withModifiers(($event: any) => (_ctx.handleCatalogItem(index)), ["prevent"])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["value", "active", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buyerItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: index,
                            value: index,
                            active: _ctx.activeTab === item.title,
                            onClick: _withModifiers(($event: any) => (_ctx.setActiveTab(item.title)), ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                onClick: _withModifiers(($event: any) => (_ctx.handleBuyerItem(index)), ["prevent"])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["value", "active", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: "v-title about",
                      onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.toAboutPage()), ["prevent"]))
                    }, "О нас")
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_v_menu, null, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          variant: "flat",
                          size: "small",
                          id: "catalog-menu-activator"
                        }, props), {
                          default: _withCtx(() => [
                            _createTextVNode(" Каталог ")
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogItems, (item, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: index,
                                value: index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    onClick: _withModifiers(($event: any) => (_ctx.handleCatalogItem(index)), ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_menu, null, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          variant: "flat",
                          size: "small",
                          id: "buyer-menu-activator"
                        }, props), {
                          default: _withCtx(() => [
                            _createTextVNode("Покупателю")
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buyerItems, (item, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: index,
                                value: index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    onClick: _withModifiers(($event: any) => (_ctx.handleBuyerItem(index)), ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      size: "small",
                      onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.handleMenuItem(6)), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("О нас")
                      ]),
                      _: 1
                    })
                  ])
                ])),
            _createElementVNode("div", {
              class: _normalizeClass(["footer-contacts", { 'pt-2': _ctx.isMobile }])
            }, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "contact",
                    onClick: _withModifiers(($event: any) => (_ctx.handleLink(item)), ["prevent"])
                  }, [
                    _createVNode(_component_v_img, {
                      src: `${_ctx.environment}${item.link}`
                    }, null, 8, ["src"]),
                    _createElementVNode("span", _hoisted_29, "+375 " + _toDisplayString(item.contact), 1)
                  ], 8, _hoisted_28))
                }), 128))
              ])
            ], 2),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: _ctx.isMobile ? 'default' : 'compact',
                    onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.downloadDocument()), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33
                    ]),
                    _: 1
                  }, 8, ["density"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.snackbar.status,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.snackbar.status) = $event)),
        timeout: _ctx.timeout,
        vertical: _ctx.vertical,
        color: _ctx.snackbarColor,
        outlined: "",
        class: "custom-snackbar-class"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.snackbar.text), 1),
          _createVNode(_component_v_avatar, {
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeSnackbar())),
            color: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-close-circle")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "timeout", "vertical", "color"]),
      _createVNode(_component_form_modal),
      _createVNode(_component_additional_modal)
    ]),
    _: 1
  }))
}